const Description = ({ desc }) => {
  return <div style={{ padding: "0vw 11vw" }}> {desc}</div>;
};

export default Description;
